module.exports = __webpack_public_path__ + "static/media/view complain.4f946590.svg";